import React, { useEffect, useRef } from "react";
import CollapsableBox from "../collapsableBox/CollapsableBox";
import WhatsappProfileEditor from "./WhatsappProfileEditor";

interface WhatsappProfileSectionProps {
    showTitle?: boolean;
    isInitiallyOpen?: boolean;
}

const WhatsappProfileSection = ({ isInitiallyOpen = false }: WhatsappProfileSectionProps) => {
    const sectionRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if(isInitiallyOpen) {
            sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [isInitiallyOpen]);

    return (
        <CollapsableBox title="Whatsapp Profile" isInitiallyOpen={isInitiallyOpen}>
            <div ref={sectionRef} className="whatsapp-profile-container">
                <WhatsappProfileEditor isOpen={true} />
            </div>
        </CollapsableBox>
    )
}

export default WhatsappProfileSection;